module.exports = __webpack_public_path__ + "statics/img/bannners.98bd07b0.png";